import React from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';

import Home from './home';
import Learn from './learn';
import Check from './check';
import Discuss from './discuss';
import NotFound from './404';
import One from './lessons/chapterOne';
import OneA from './lessons/OneA';
import OneB from './lessons/OneB';
import OneC from './lessons/OneC';
import Two from './lessons/chapterTwo';
import TwoA from './lessons/TwoA';
import TwoB from './lessons/TwoB';
import Three from './lessons/chapterThree';
import ThreeA from './lessons/ThreeA';
import ThreeB from './lessons/ThreeB';
import ThreeC from './lessons/ThreeC';
import ThreeD from './lessons/ThreeD';
import ThreeE from './lessons/ThreeE';
import ThreeF from './lessons/ThreeF';
import Four from'./lessons/chapterFour';
import FourA from'./lessons/FourA';
import FourB from './lessons/FourB';
import FourC from './lessons/FourC';
import FourD from './lessons/FourD';
import FourE from './lessons/FourE';
import Five from './lessons/chapterFive';
import FiveA from './lessons/FiveA';
import FiveB from './lessons/FiveB';
import FiveC from './lessons/FiveC';

import Quiz1 from './quizzes/test1';
import Quiz1a from './quizzes/quizpages/quizpage_1a';
import Quiz1b from './quizzes/quizpages/quizpage_1b';
import Quiz1c from './quizzes/quizpages/quizpage_1c';
import Quiz2a from './quizzes/quizpages/quizpage_2a';
import Quiz2b from './quizzes/quizpages/quizpage_2b';
import Quiz3ab from './quizzes/quizpages/quizpage_3ab';
import Quiz3cd from './quizzes/quizpages/quizpage_3cd';
import Quiz3e from './quizzes/quizpages/quizpage_3e';
import Quiz4a from './quizzes/quizpages/quizpage_4a';
import Quiz4b from './quizzes/quizpages/quizpage_4b';
import Quiz4c from './quizzes/quizpages/quizpage_4c';
import Quiz4d from './quizzes/quizpages/quizpage_4d';
import Quiz4e from './quizzes/quizpages/quizpage_4e';

import DesignTool from './designtool';
import Testing from './testing';
import IntakeTool from './intaketool';
import RotaryTool from './rotarydesign';
import BeltTool from './belttool';

const Main = () => {
  return (
    <Switch> {/* The Switch decides which component to show based on the current URL.*/}
        <Route exact path='/' component={Home}></Route>
        <Route exact path='/learn' component={Learn}></Route>
        <Route exact path='/check' component={Check}></Route>
        <Route exact path='/discuss' component={Discuss}></Route>
        <Route exact path='/learn/one' component={One}></Route>
        <Route exact path='/learn/one/a' component={OneA}></Route>
        <Route exact path='/learn/one/b' component={OneB}></Route>
        <Route exact path='/learn/one/c' component={OneC}></Route>
        <Route exact path='/learn/two' component={Two}></Route>
        <Route exact path='/learn/two/a' component={TwoA}></Route>
        <Route exact path='/learn/two/b' component={TwoB}></Route>
        <Route exact path='/learn/three' component={Three}></Route>
        <Route exact path='/learn/three/a' component={ThreeA}></Route>
        <Route exact path='/learn/three/b' component={ThreeB}></Route>
        <Route exact path='/learn/three/c' component={ThreeC}></Route>
        <Route exact path='/learn/three/d' component={ThreeD}></Route>
        <Route exact path='/learn/three/e' component={ThreeE}></Route>
        <Route exact path='/learn/three/f' component={ThreeF}></Route>
        <Route exact path='/learn/four' component={Four}></Route>
        <Route exact path='/learn/four/a' component={FourA}></Route>
        <Route exact path='/learn/four/b' component={FourB}></Route>
        <Route exact path='/learn/four/c' component={FourC}></Route>
        <Route exact path='/learn/four/d' component={FourD}></Route>
        <Route exact path='/learn/four/e' component={FourE}></Route>
        <Route exact path='/learn/five' component={Five}></Route>
        <Route exact path='/learn/five/a' component={FiveA}></Route>
        <Route exact path='/learn/five/b' component={FiveB}></Route>
        <Route exact path='/learn/five/c' component={FiveC}></Route>

        <Route exact path='/check/quiz1' component={Quiz1}></Route>
        <Route exact path='/getstarted' component={Learn}></Route> {/*temp until the get started page is made*/}

        <Route exact path='/check/1a' component={Quiz1a}></Route>
        <Route exact path='/check/1b' component={Quiz1b}></Route>
        <Route exact path='/check/1c' component={Quiz1c}></Route>
        <Route exact path='/check/2a' component={Quiz2a}></Route>
        <Route exact path='/check/2b' component={Quiz2b}></Route>
        <Route exact path='/check/3ab' component={Quiz3ab}></Route>
        <Route exact path='/check/3cd' component={Quiz3cd}></Route>
        <Route exact path='/check/3e' component={Quiz3e}></Route>
        <Route exact path='/check/4a' component={Quiz4a}></Route>
        <Route exact path='/check/4b' component={Quiz4b}></Route>
        <Route exact path='/check/4c' component={Quiz4c}></Route>
        <Route exact path='/check/4d' component={Quiz4d}></Route>
        <Route exact path='/check/4e' component={Quiz4e}></Route>

        <Route exact path='/design' component={DesignTool}></Route>
        <Route exact path='/testing' component={Testing}></Route>
        <Route exact path='/design/intake' component={IntakeTool}></Route>
        <Route exact path='/design/rotary' component={RotaryTool}></Route>
        <Route exact path='/design/belt' component={BeltTool}></Route>

        <Route path='/404' component={NotFound}></Route>
        <Redirect to='/404' />
    </Switch>
  );
}

export default Main;